export enum Actions {
  SELECT_USER_NFT = '@NFT/SELECT_USER_NFT',
  SELECT_NFT_STORE_ITEM = '@NFT/SELECT_NFT_STORE_ITEM',
  UPDATE_NFT_STORE_ITEM_LIST = '@NFT/UPDATE_NFT_STORE_ITEM_LIST',
  UPDATE_NFT_USER_LIST = '@NFT/UPDATE_NFT_USER_LIST',
  UPDATE_ALL_NFT_LIST = '@NFT/UPDATE_ALL_NFT_LIST',
  RELOAD = '@NFT/RELOAD'
}
